"use client";

import PropTypes from "prop-types";
import classNames from "classnames";

import PeopleSvg from "assets/svg/people.svg";
import MembershipFlagForPlatinum from "assets/svg/duration-of-membership-platinum.svg";

import { stringToSlug } from "helpers/string-to-slug";
import { createImageUrl } from "helpers/create-image-url";

import { accountTypes } from "./widgets";

import SendMessageButton from "components/common/send-message-button";
import ShowPhone from "components/common/show-phone/ShowPhone";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import styles from "./sidebar.module.css";

const CompanyBadgeSidebar = ({ data }) => {
  const { owner, id: listingId } = data;
  const {
    account: { durationOfMembership = 0, type, id, businessName, logo, phoneNumber, membershipType, name: accountName },
    member: { name: memberName },
  } = owner || {};

  const accountSlug = accountName ? `${stringToSlug(accountName, "-")}-${id}` : id;
  const isAccountTypeCorporate = type === "corporate";
  const isMemberShipTypeSpecialPackage = membershipType === "platinum" || membershipType === "platinum plus";
  const unwantedMemberShipsForBand = ["platinum", "platinum plus", "standart", "hesabını bilen"];
  const isBandVisible = membershipType && !unwantedMemberShipsForBand.includes(membershipType);
  const isBusinessNameEmlak = businessName === "Emlak";

  const logoImage = createImageUrl(logo, {
    width: 240,
    height: 150,
  });

  const specialPackagesClasses = classNames({
    [styles.specialPackagesWrap]: isMemberShipTypeSpecialPackage,
  });

  const getMembershipYear = () =>
    isMemberShipTypeSpecialPackage ? (
      <div className={styles.platinumYearWrap}>
        <span className={styles.platinumYearIconWrap}>
          <MembershipFlagForPlatinum />
        </span>
        <span className={styles.platinumYearRadial}>{durationOfMembership}.</span>
        <span className={styles.platinumYearFlag}>YIL</span>
      </div>
    ) : (
      <span className={styles.yearBadge}>{`${durationOfMembership}. Yıl`}</span>
    );

  return (
    <div className={styles.wrapper}>
      <div className={styles.actionsWrap}>
        <ShowPhone listItemInfo={data} phoneNumber={phoneNumber} gtmEventLabel="detay" hasGreenBackground={true} />
        <SendMessageButton listingId={listingId} />
      </div>
      <div className={specialPackagesClasses}>
        {isMemberShipTypeSpecialPackage && <div className={styles.band}>{accountTypes[membershipType]}</div>}
        <div className={styles.infoWrap}>
          <div className={styles.logoWrap}>
            {durationOfMembership > 0 && getMembershipYear()}
            <a
              href={isAccountTypeCorporate ? `/emlak-ofisleri-detay/${accountSlug}` : "javascript:void(0)"}
              className={styles.logoAction}
            >
              {logo ? <LazyImage src={logoImage} alt={logoImage} height="73" /> : <PeopleSvg />}
            </a>
          </div>
          <div className={styles.titlesWrap}>
            {isBandVisible && <span className={styles.accountType}>{accountTypes[membershipType]}</span>}
            <h4 className={styles.userName} title={memberName}>
              {memberName}
            </h4>
            {accountName && (
              <span className={styles.companyName} title={accountName}>
                {accountName}
              </span>
            )}
          </div>
        </div>
      </div>
      {isAccountTypeCorporate && (
        <div className={styles.redirectWrap}>
          <a
            href={type ? `/emlak-ofisleri-detay/${accountSlug}` : "javascript:void(0);"}
            title={`${accountName} Profiline Git`}
          >
            {isBusinessNameEmlak && "Firma"} Profiline Git
          </a>
        </div>
      )}
    </div>
  );
};

CompanyBadgeSidebar.propTypes = {
  data: PropTypes.object,
};

export default CompanyBadgeSidebar;
